function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#212b35",
  d: "M202.624 478.016L0 291.36l70.512-76.56 121.456 111.856L431.44 33.984 512 99.904z"
});

function SvgCheckMarkBlackOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: ".65em",
    height: ".65em",
    viewBox: "0 0 512 512"
  }, props), _ref);
}

export default SvgCheckMarkBlackOutline;